'use client';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { FC, ReactNode } from 'react';
import Typography from '../Typography';
import Icon from '../Icon';
import cn from '../Utils/cn';

type CheckButtonType = {
	title?: string;
	checked?: boolean;
	name?: string;
	onClick?: () => void;
	buttonSize?: string;
};

const CheckButton: FC<CheckButtonType> = ({ title, checked = false, name="radio", onClick, buttonSize }) => {
	return (
		<label
			onClick={onClick}
			className={cn(
				'flex flex-col gap-4 items-center justify-center rounded-xl w-40 h-40 border border-solid border-brand-main', 
				'cursor-pointer',
				'pt-4',
				buttonSize === 'small' && 'w-32 h-32',
				'hover:bg-brand-dark hover:text-white hover:border-brand-main',
				'transition-all duration-200 ease-in-out',
				checked && 'bg-brand-main text-white'
			)}
		>
			<input type="radio" name={name} checked={checked} className="scale-[0] absolute" />

			<Icon className={cn('fi fi-br-hand text-2xl', title === 'Sim' && 'rotate-180')} />

			{title ? (
				<Typography variant="body-1" className="text-center">
					{title}
				</Typography>
			) : null}
		</label>
	);
};
type BooleanRadioGroupType = {
	label: string | string[];
	setValue: (val: boolean) => void;
	value: boolean;
	name?: string;
	buttonSize?: string;
};

const BooleanRadioGroup: FC<BooleanRadioGroupType> = ({ label = null, setValue = () => {}, value = null, name, buttonSize }) => {
	const radioChange = (e: boolean) => {
		setValue(e);
	};

	return (
		<div className='mb-8'>
			{(Array.isArray(label) ? label : [label]).map((item, index) => (
				<Typography key={index} variant="body2" component="h3" className="mt-12 mb-6 font-medium text-base-grey-5">
					{item}
				</Typography>
			))}

			<div className="flex flex-row gap-8">
				<CheckButton
					name={name}
					title="Sim"
					buttonSize={buttonSize}
					checked={value === true}
					onClick={() => {
						radioChange(true);
					}}
				/>
				<CheckButton
					name={name}
					title="Não"
					buttonSize={buttonSize}
					checked={value === false}
					onClick={() => {
						radioChange(false);
					}}
				/>
			</div>
		</div>
	);
};

export default BooleanRadioGroup;
